<template>
    <hts-drawer
        v-model="visible"
        :title="$t('labels.addVehicleCategory')"
        :submit="handleSubmitFormAddVehicleCategory"
        :rules="rulesAddVehicleCategory"
        :loading="loading"
        @close="closeOverSide"
        @undo="undo()"
        @visible="getData">
        <hts-card :title="$t('labels.generalInformation')">
            <div
                class="grid gap-4"
                :class="columnClass">
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.name"
                    :label="$t('labels.vehicleModule.category.categoryName')"
                    :color="props.color"
                    required
                    name="vehicleModule.category.categoryName"
                    prop="vehicleModule.category.categoryName" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.from"
                    :label="$t('labels.fromKg')"
                    required
                    :color="props.color"
                    type="number"
                    disabled
                    name="fromKg"
                    prop="fromKg" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.to"
                    :label="$t('labels.comeFirstKg')"
                    :color="props.color"
                    type="number"
                    name="comeFirstKg"
                    prop="toKg" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.wheelNumber"
                    :label="$t('labels.vehicleModule.category.wheelNumber')"
                    :color="props.color"
                    type="number"
                    name="vehicleModule.category.wheelNumber"
                    prop="vehicleModule.category.wheelNumber" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.priceTires"
                    :label="$t('labels.vehicleModule.category.priceTires')"
                    :color="props.color"
                    type="number"
                    name="vehicleModule.category.priceTires"
                    prop="vehicleModule.category.priceTires" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.depreciationTires"
                    :label="$t('labels.vehicleModule.category.depreciationTires')"
                    :color="props.color"
                    type="number"
                    name="vehicleModule.category.depreciationTires"
                    prop="vehicleModule.category.depreciationTires" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.repairingPrice"
                    :label="$t('labels.vehicleModule.repairingPrice')"
                    :color="props.color"
                    type="number"
                    name="vehicleModule.repairingPrice"
                    prop="vehicleModule.repairingPrice" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.liquidationValue"
                    :label="$t('labels.liquidationValue')"
                    :color="props.color"
                    type="number"
                    name="liquidationValue"
                    prop="liquidationValue" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.oilMaterialAssumption"
                    :label="$t('labels.oilMaterialAssumption')"
                    :color="props.color"
                    type="number"
                    name="oilMaterialAssumption"
                    prop="oilMaterialAssumption" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.insuranceValue"
                    :label="$t('labels.insuranceValueAmountYear')"
                    :color="props.color"
                    type="number"
                    name="insuranceValue"
                    prop="insuranceValue" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.depreciationRate"
                    :label="$t('labels.depreciationRateAmountYear')"
                    :color="props.color"
                    type="number"
                    name="depreciationRate"
                    prop="depreciationRate" />
                <hts-form-input
                    v-model="dataFormAddVehicleCategory.description"
                    :label="$t('labels.description')"
                    :color="props.color"
                    name="description"
                    prop="description" />
                <!--
                  :checked="isCheckAll"
                  @change="actionCheckAll"
                -->
            </div>
        </hts-card>
        <template #footer>
            <div class="flex flex-row gap-5">
                <hts-form-button
                    icon-name="hi-check-icon"
                    icon-position="right"
                    color="primary"
                    type="submit"
                    :loading="creating">
                    {{ $t('labels.save') }}
                </hts-form-button>
                <hts-form-button
                    icon-name="hi-x-mark-icon"
                    icon-position="right"
                    color="error"
                    @click="visible = false">
                    {{ $t('labels.cancel') }}
                </hts-form-button>
            </div>
        </template>
    </hts-drawer>
</template>

<script setup lang="ts">
import form from './import/form'
import { $api, $urlSystem } from '#imports'
const { rules } = form
const { $formatters }: any = useNuxtApp()

const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  sizeSlideOver: {
    type: String,
    default: 'small'
  },
  sizeItemInput: {
    type: String,
    default: 'small'
  },
  column: {
    type: Number,
    default: 1
  },
  defaultValue: {
    type: Number,
    default: 0
  }
})

const dataFormAddVehicleCategory = reactive({ ...form.initVehicleCategory })
const emits = defineEmits(['close', 'refreshTables', 'newVehicleCategory'])
const visible = ref(false)
const creating = ref(false)
const openAddCategory = () => {
  visible.value = true
}
defineExpose({
  openAddCategory
})
const closeOverSide = () => {
  visible.value = false
}
const undo = () => {
  Object.assign(dataFormAddVehicleCategory, { ...form.initVehicleCategory })
}

const handleSubmitFormAddVehicleCategory = () => {
  const api = $urlSystem.vehicle.category.add
  creating.value = true
  $api(api, { body: dataFormAddVehicleCategory })
    .then((data: any) => {
      const resData: any = data.data.value
      if (resData.success) {
        Object.assign(dataFormAddVehicleCategory, { ...form.initVehicleCategory })
        emits('refreshTables')
        emits('newVehicleCategory', resData.data)
        process.client && $toast().success($t('labels.addSuccess'))
        emits('close')
        undo()
        visible.value = false
      }
      creating.value = false
    })
    .catch(() => {
      creating.value = false
    })
}
const columnClass = computed(() => {
  if ($lodash.inRange(props.column, 1, 12)) {
    return `grid-cols-${props.column}`
  }

  return 'grid-cols-1'
})

const rulesAddVehicleCategory = computed(() => {
  const data: {[key: string]: any} = rules.addVehicleCategory
  if (typeof dataFormAddVehicleCategory.from === 'number' && typeof dataFormAddVehicleCategory.to === 'number') {
    data.toKg = `numeric|validationCustom:${(dataFormAddVehicleCategory.to || 0) >= dataFormAddVehicleCategory.from}--Giá trị của trường "Đến (kg)"
    phải lớn hơn ${$formatters.formatCurrency(dataFormAddVehicleCategory.from).replaceAll(',', 'LA==')}`
  }
  return data
})

const loading = ref(false)//

const getData = async () => {
  const api = $urlSystem.vehicle.category.lastCategory
  loading.value = true
  try {
    const res = await $api(api)
    const resData: any = res?.data.value
    if (resData.success) {
      if (resData.data) {
        dataFormAddVehicleCategory.from = resData.data?.to || 0
      }
    }
    loading.value = false
    return null
  } catch (e: any) {
    loading.value = false
  }
}
</script>
